module.exports = __webpack_public_path__ + "img/britek-white.3bc74b57.svg";